import { render, staticRenderFns } from "./TemplateEmailDetail.vue?vue&type=template&id=2e309f9d&scoped=true&"
import script from "./TemplateEmailDetail.vue?vue&type=script&lang=js&"
export * from "./TemplateEmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEmailDetail.vue?vue&type=style&index=0&id=2e309f9d&prod&lang=css&"
import style1 from "./TemplateEmailDetail.vue?vue&type=style&index=1&id=2e309f9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e309f9d",
  null
  
)

export default component.exports